<template>

    <div v-if="dissave" style="position:absolute; top: 300px;   width: 100%; z-index:100;  ">
        <Circle4 size="120px" class="mx-auto"></Circle4>
    </div>


    <div>
        <h2 class="text-center text-primary">Тавтиши маълумоти {{ this.header }}</h2>
        <div class="row">
            <div class="col-3">

                <h3 class="text-center">Нишондиҳанда</h3>

                <div class="list-group">

                    <!-- <button  v-for="t in this.$store.state.ter" :key="t" @click="refresh(t.Terid)" class="list-group-item list-group-item-action @ViewBag.act0">{{t.NameTJ}} </button> -->

                    <select class="form-control" v-model="idclass">
                        <option v-for="t in this.class" :key="t" :value="t.ID">{{ t.Name }}</option>

                    </select>

                </div>

                <button class="btn btn-primary w-50 mt-3" @click="GetData">Ok</button>
                <!-- <button class="btn btn-primary" @click="exportCSV">Экспорт</button> -->
            </div>

            <div class="col-9">

                <!--
<p>
    <input type="button" value="Экспорт ба Excel" class="btn btn-primary" onclick="exportReportToExcel()" />
    <input type="button" value="Чопкунӣ" class="btn btn-primary" onclick="imprimir()" />
</p>
-->


                <div>

          <DataTable v-model:filters="filters" :value="this.list" removableSort filterDisplay="row" ref="dt"
                    tableStyle="min-width: 50rem" size='small' showGridlines stripedRows paginator :rows="50"
                    :rowsPerPageOptions="[20, 50, 100]">
                    <template #header>
                      <div class="row">
                      <div class="col-6 text-left">
                        Шумораи сабтҳо: {{ list.length}}
                      </div>
                      <div class="col-6 text-right">
                        <span class="p-input-icon-left">
                          <i class="pi pi-search" />
                          <InputText v-model="filters['global'].value" placeholder="Ҷустуҷӯ" />
                        </span>
                      </div>
                    </div>
                    </template>
                    <template #empty> Сабт мавҷуд нест. </template>
                    <template #loading> Loading customers data. Please wait. </template>
                    <Column field="np" header="№" sortable  class="text-center">
                      <template #body="{ data }">
                        {{ data.np }}
                      </template>
                      <template #filter="{ filterModel, filterCallback }">
                        <InputText v-model="filterModel.value" type="text" @input="filterCallback()"
                          class="p-column-filter" placeholder="" />
                      </template>
                    </Column>
                    <Column field="head" header="Сардори хоҷагӣ" sortable  class="text-center">
                      <template #body="{ data }">
                        {{ data.head }}
                      </template>
                      <template #filter="{ filterModel, filterCallback }">
                        <InputText v-model="filterModel.value" type="text" @input="filterCallback()"
                          class="p-column-filter" placeholder="" />
                      </template>
                    </Column>
                    <Column field="number" header="Рақами китоб" sortable  class="text-center" >
                      <template #body="{ data }">
                        {{ data.number }}
                      </template>
                      <template #filter="{ filterModel, filterCallback }">
                        <InputText v-model="filterModel.value" type="text" @input="filterCallback()"
                          class="p-column-filter" placeholder="" />
                      </template>
                    </Column>
                    <Column field="tername" header="Минтақа" sortable >
                      <template #body="{ data }">
                        {{ data.tername }}
                      </template>
                      <template #filter="{ filterModel, filterCallback }">
                        <InputText v-model="filterModel.value" type="text" @input="filterCallback()"
                          class="p-column-filter" placeholder="" />
                      </template>
                    </Column>
                    <Column field="c01" :header="ch1" sortable  class="text-center">
                      <template #body="{ data }">
                        {{ data.c01 }}
                      </template>
                      <template #filter="{ filterModel, filterCallback }">
                        <InputText v-model="filterModel.value" type="text" @input="filterCallback()"
                          class="p-column-filter" placeholder="" />
                      </template>
                    </Column>
                    <Column v-if="cv2" field="c02" :header="ch2" sortable  class="text-center">
                      <template #body="{ data }">
                        {{ data.c02 }}
                      </template>
                      <template #filter="{ filterModel, filterCallback }">
                        <InputText v-model="filterModel.value" type="text" @input="filterCallback()"
                          class="p-column-filter" placeholder="" />
                      </template>
                    </Column>
                    <Column v-if="cv3" field="c03" :header="ch3" sortable  class="text-center"> 
                      <template #body="{ data }" >
                        {{ data.c03 }}
                      </template>
                      <template #filter="{ filterModel, filterCallback }" >
                        <InputText v-model="filterModel.value" type="text" @input="filterCallback()"
                          class="p-column-filter" placeholder="" />
                      </template>
                    </Column>
                    <Column  v-if="cv4" field="c04" :header="ch4" sortable  class="text-center">
                      <template #body="{ data }">
                        {{ data.c04 }}
                      </template>
                      <template #filter="{ filterModel, filterCallback }">
                        <InputText v-model="filterModel.value" type="text" @input="filterCallback()"
                          class="p-column-filter" placeholder="" />
                      </template>
                    </Column>
                     
                    <Column field="" header=" ">
                      <template #body="{ data }" >
                        <!-- <router-link target="_blank" class="collapse-item" :to="'/print/'+this.$route.params.typ+'/'+data.ID" active-class="active"><i class="m-2 pi pi-print" style="font-size: 1.5rem; color:rgb(66, 134, 224)" /></router-link> -->
                        <button  @click="Edit(data.id)" class="btn btn-secondary1"   ><i class="m-2 pi pi-file-edit" style="font-size: 1.5rem; color:rgb(66, 134, 224)" /></button>
                      </template>
                      
                    </Column>
                  </DataTable>
                </div>
            </div>
        </div>
    </div>


    
  <mod v-if="isShowRep" @close="closemod" @scroll="scrollmod" >
  
    <template v-slot:body>
      <member   :id="idrep" ref="repComponent" @close="closemod"></member>
      </template>
  
  </mod>


</template>



<script>
// import Select from '../../node_modules00/primevue/select/Select.vue';

import { FilterMatchMode } from 'primevue/api';

 import mod from './ModalForm.vue'
import member from './Members2.vue'

export default {
    //   components: { Select },
  components:{mod, member},
  props: ["typ"],
    watch: {
    "$route.params.typ"(value) {
      // alert(-1)
      // alert(value)
      // alert(-2)
      // this.hideSave = false; 
      this.refresh(value);
    //  this.initTime();
      
    }
  },
    data() {

        return {
                  isShowRep:false,
      isShowPrint:false,
      idrep:0,
            list: '',
            dissave: false,
            header: '',


            class: [],
            idclass: 0,
             filters: {
        global: { value: null, matchMode: FilterMatchMode.CONTAINS },
        np: { value: null, matchMode: FilterMatchMode.EQUALS },
        head: { value: null, matchMode: FilterMatchMode.STARTS_WITH },
        number: { value: null, matchMode: FilterMatchMode.STARTS_WITH },
        tername: { value: null, matchMode: FilterMatchMode.STARTS_WITH },
        c01: { value: null, matchMode: FilterMatchMode.STARTS_WITH },
        c02: { value: null, matchMode: FilterMatchMode.STARTS_WITH },
        c03: { value: null, matchMode: FilterMatchMode.STARTS_WITH },
        c04: { value: null, matchMode: FilterMatchMode.STARTS_WITH }
        

      },

      ch1:"",
      ch2:"Ҳосил (сентнер)",
      ch3:"Масоҳат (сотих)",
      ch4:"Ҳосил (сентнер)",
      cv1:true,
      cv2:false,
      cv3:false,
      cv4:false,




        }
    },

    methods: {

        async GetData() {
            this.dissave = true;
            console.log('start report3');
            try {
                await this.$api( "/api/check/" + this.$store.state.terid + "/" + this.idclass + " /")
                  //  .then(res => res.json())
                    .then(data => this.list = data)
                    .catch(error => {
                        console.error("There was an error!", error)
                    });

                console.log('stop report3');
            }
            catch (ex) {
                console.log(ex);

            }
            finally {
                console.log('finish');

            }
            this.dissave = false;
        },
    closemod(){
  this.isShowPrint=false;
  this.isShowRep=false;
},

scrollmod(){
  this.$refs.repComponent.onScroll()
  //  console.log('modal scrolled')

},
        refresh(typ) {

          switch (typ){
            case '1':
            this.header="замин";
            this.ch1='Масоҳат (сотих)';
            this.cv2=true;
            this.cv3=true;
            this.cv4=true;
            break;
            case '2':
            this.header="чорво";
            this.ch1='Ҳамагӣ (сар)'
            this.cv2=false;
            this.cv3=false;
            this.cv4=false;
            break;
            case '3':
            this.header="техника";
            this.ch1='Шумора, адад'
            this.cv2=false;
            this.cv3=false;
            this.cv4=false;
            break;

          }


    //  alert(typ)
        this.class=this.$store.state.class.filter(x=>x.Part==typ)   
if (this.class.length>0)
this.idclass= Object.values(this.class[0])[0]

        this.GetData();

        },
            async Edit(id) {
      console.log("edit id=", id);

      await this.$api("/api/data/2/0/" + id)
      //  .then((res) => res.json())
        .then((data) => (this.$store.state.household = data))
        .catch((error) => {
          console.error("There was an error!", error);
          return;
        });

 this.idrep=id;

 this.isShowRep=true;

    },

    exportCSV() {
            this.$refs.dt.exportCSV({
        fileName: "products.csv",
      
        separator: ";"  // <-- русский/европейский вариант
      });
        }


    },

    mounted() {

      if (this.typ > 0)
 this.refresh(this.typ)

    }



}
</script>
